<template>
	<div class="campaigns-subview">
		<div class="subview-segment" v-if="party">
			<form-campaign-party :party="party"  :button-title="env.msg('bas.add')"
								 :campaign-title="env.msg('campaign.addPartyTo', '<b>'+partyName+'</b>')"
								 :empty-title="env.msg('err.empty')"
								 @refresh="refreshTable"></form-campaign-party>
		</div>
		<div class="subview-segment">
			<crm-table ref="table" :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, watch} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import {addContextParams, ContextKey, getIntValue, hasValue, injectContext, OPPORTUNITY_REFS} from "@t/fd/AppContext.ts";
import CrmTable from "@/vue/table/CrmTable.vue";
import FormCampaignParty from "@/vue/form/FormCampaignParty";
import {SrcType} from "@t/meta/SourceType.ts";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));
const table = ref<InstanceType<typeof CrmTable> | null>(null);

const party = computed<number>(() => {
	if (sourceType.value === SrcType.PARTY) {
		let idValue = sourceId.value;
		return typeof idValue === "number" ? idValue : parseInt(idValue);
	}
	if (hasValue(ctx.value, ContextKey.PERSON)) return getIntValue(ctx.value, ContextKey.PERSON);
	if (hasValue(ctx.value, ContextKey.BRANCH)) return getIntValue(ctx.value, ContextKey.BRANCH);
	if (hasValue(ctx.value, ContextKey.CUSTOMER)) return getIntValue(ctx.value, ContextKey.CUSTOMER);
	return 0;
});

const partyName = ref<string>("");
watch(party, (pid) => {
	if (pid) {
		env.parties([ pid ]).then(names => {
			partyName.value = names.length > 0 ? names[0].name : "";
		});
	} else partyName.value = "";
}, { immediate: true });


function refreshTable() {
	if (table.value) table.value.refresh();
}


const restApi = computed<string>(() => {
	let ep = "api/campaignparties/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});

</script>

<style>

</style>